import { useMemo } from 'react'

import { paymentAdapter } from '@/entities/Payments'

import { useProductPaymentsQuery } from './use-product-payments-query'

export const useProductPaymentsData = (productId: number) => {
	const { data, isFetching, isLoading } = useProductPaymentsQuery(productId)

	const installmentData = useMemo(
		() => (data?.data?.PAYMENTS ? paymentAdapter(data.data.PAYMENTS[`INSTALLMENT`] ?? []) : null),
		[data?.data?.PAYMENTS]
	)
	const creditData = useMemo(
		() => (data?.data?.PAYMENTS ? paymentAdapter(data.data.PAYMENTS[`CREDIT`] ?? []) : null),
		[data?.data?.PAYMENTS]
	)
	const limitData = useMemo(
		() => (data?.data?.PAYMENTS ? paymentAdapter(data.data.PAYMENTS[`LIMIT`] ?? []) : null),
		[data?.data?.PAYMENTS]
	)
	const partsData = useMemo(
		() => (data?.data?.PAYMENTS ? paymentAdapter(data.data.PAYMENTS[`PARTS`] ?? []) : null),
		[data?.data?.PAYMENTS]
	)

	const payload = useMemo(
		() => ({
			data: {
				installmentData,
				creditData,
				limitData,
				partsData
			},
			isLoading: isFetching || isLoading
		}),
		[data?.data?.PAYMENTS]
	)

	return payload
}
